import React, { useContext, useEffect, useState, useRef } from "react";
import Navbar from "../../components/Home/navbar/Navbar";
import Rating from "@mui/material/Rating";
import {
  allProductIdApi,
  toggleWishlistApi,
  wishlistApi,
} from "../../Apis/ProductApi";
import { UserAuthContext } from "../../App";
import RangeSlider from "../UI/RangeSlider";
import ProductsCard from "../UI/AllProducts/ProductsCard";
import Seller from "../UI/AllProducts/Seller";
import "./AllProducts.css";
import { getAuth } from "@firebase/auth";
import {
  allMainCategoryApi,
  subChildCatergoryApi,
  mainCategoryApi,
} from "../../Apis/CategoryApi";

const AllProducts = ({ index, initialLikedState }) => {
  const [allProductsData, setAllProductsData] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subCategoryDropdown, setSubcategoryDropdown] = useState(false);
  const [sortByDropdown, setSortByDropdown] = useState(false);
  const [price, setPrice] = useState([null, null]);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [selectedOption, setSelectedOption] = useState("Featured");
  const [productsTab, setProductsTab] = useState(0);
  const [isPriceRangeOpen, setIsPriceRangeOpen] = useState(false);
  const [isProductRatingOpen, setIsProductRatingOpen] = useState(false);
  const [isSellerTypeOpen, setIsSellerTypeOpen] = useState(false);
  const [mainCategory, setMainCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [sellerTypes, setSellerTypes] = useState([]);
  const [sortType, setSortType] = useState(0);
  const dropdownRef = useRef(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubCategoryDetails, setSelectedSubCategoryDetails] = useState(
    {}
  );
  const [rating, setRating] = useState([]);
  const allProductsTab = ["Products", "Suppliers"];

  const productsTabContent = [
    {
      panel: (
        <ProductsCard
          selectedCategory={selectedCategory}
          min={min}
          max={max}
          selectedSubCategory={selectedSubCategory}
          sortType={sortType}
          sellerTypes={sellerTypes}
          rating={rating}
        />
      ),
    },
    { panel: <Seller /> },
  ];

  const [refresh, setRefresh] = useState(false);
  const options = {
    Featured: 1,
    "Price - Low to High": 2,
    "Price - High to Low": 3,
    "Rating - High to Low": 4,
    "A - Z": 5,
    "Z - A": 6,
  };

  const getMainCategory = async () => {
    try {
      const response = await mainCategoryApi();
      setMainCategory(response?.category);
      if (response?.category) {
        await getSubChildCategory(selectedCategory);
      }
    } catch (error) {
      console.log("Error fetching the category", error);
    }
  };

  useEffect(() => {
    getMainCategory();
  }, []);

  const getSubChildCategory = async (selectedCategory) => {
    try {
      const response = await subChildCatergoryApi(selectedCategory);
      setSubCategories(response?.category);
    } catch (error) {
      console.log("Error in fetching the sub and child category", error);
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      getSubChildCategory(selectedCategory);
    }
  }, [selectedCategory]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const subCategoryToggle = () => {
    setSubcategoryDropdown(!subCategoryDropdown);
  };

  const sortByToggle = () => {
    setSortByDropdown(!sortByDropdown);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setDropdownOpen(false);
    setSelectedSubCategory("");
    setSelectedSubCategoryDetails({});
  };

  const handleSubCategorySelect = (subCategory) => {
    setSelectedSubCategory(subCategory.subCategory);
    setSelectedSubCategoryDetails(subCategory);
    setSubcategoryDropdown(false);
  };

  useEffect(() => {
    setMin(price[0]);
  }, [price[0]]);

  useEffect(() => {
    setMax(price[1]);
  }, [price[1]]);

  useEffect(() => {
    if (sortByDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sortByDropdown]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
      setSortByDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setSortType(options[option]);
    setSortByDropdown(false);
  };

  const handleSellerTypeChange = (sellerType) => {
    setSellerTypes((prev) =>
      prev.includes(sellerType)
        ? prev.filter((type) => type !== sellerType)
        : [...prev, sellerType]
    );
  };

  const handleRatingChange = (value) => {
    setRating((prevRating) =>
      prevRating.includes(value)
        ? prevRating.filter((item) => item !== value)
        : [...prevRating, value]
    );
  };

  const ComponentA = () => (
    <div className="w-[232px] h-[232px]">
      <div className="w-[232px] flex items-center justify-between">
        <p className="w-[16px] h-[18px] text-[#ABABAB] font-medium text-[12px]">
          ₹0
        </p>
        <p className="w-[46px] h-[18px] text-[#ABABAB] font-medium text-[12px]">
          ₹10,000
        </p>
      </div>

      <div>
        <RangeSlider price={price} setPrice={setPrice} />
      </div>

      <p className="w-[87px] h-[21px] font-medium text-[14px] text-black">
        Lowest Price
      </p>

      <input
        type="number"
        value={min}
        onChange={(e) => {
          setMin(e.target.value);
          setPrice([e.target.value, max]);
        }}
        placeholder="₹2,000"
        className="w-[232px] h-[38px] rounded-[3px] drop-shadow-[0_0px_1px_rgba(0,0,0,0.20)] p-[10px] placeholder:w-[41px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] placeholder:text-black mt-[8px] font-medium text-[12px] text-black"
      />
      <p className="w-[92px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
        Highest Price
      </p>

      <input
        type="number"
        value={max}
        onChange={(e) => {
          setMax(e.target.value);
          setPrice([min, e.target.value]);
        }}
        placeholder="₹7,000"
        className="w-[232px] h-[38px] rounded-[3px] drop-shadow-[0_0px_1px_rgba(0,0,0,0.20)] p-[10px] placeholder:w-[41px] placeholder:h-[18px] placeholder:font-medium placeholder:text-[12px] placeholder:text-black mt-[8px] font-medium text-[12px] text-black"
      />
    </div>
  );

  const ComponentB = () => (
    <div className="w-[210px] h-[170px] flex flex-col gap-y-[20px]">
      {[
        { label: "4.5 - 5.0", value: 5.0 },
        { label: "4 - 4.5", value: 4.5 },
        { label: "3.5 - 4", value: 4.0 },
        { label: "0 - 3.5", value: 1.5 },
      ].map(({ label, value }) => (
        <div
          key={value}
          className="flex flex-row gap-x-[5px] items-center justify-start w-[220px]"
        >
          <input
            type="checkbox"
            className="w-[16px] h-[16px] bg-[#FF6300]"
            onChange={() => handleRatingChange(label)}
            checked={rating.includes(label)}
          />
          <p className="w-[60px] h-[20px] font-medium text-[14px]">{label}</p>
          <Rating
            name="half-rating-read"
            defaultValue={value}
            precision={0.5}
            readOnly
          />
        </div>
      ))}
    </div>
  );

  const ComponentC = () => (
    <div className="w-[210px] h-[150px] flex flex-col gap-y-[20px]">
      <div className="flex flex-row gap-x-[10px] items-center justify-start w-[220px]">
        <input
          type="checkbox"
          className="w-[16px] h-[16px] bg-[#FF6300]"
          onChange={() => handleSellerTypeChange("Manufacturer")}
          checked={sellerTypes.includes("Manufacturer")}
        />
        <p className="w-[97px] h-[21px] font-medium text-[14px] text-black">
          Manufacturer
        </p>
      </div>

      <div className="flex flex-row gap-x-[10px] items-center justify-start w-[220px]">
        <input
          type="checkbox"
          className="w-[16px] h-[16px] bg-[#FF6300]"
          onChange={() => handleSellerTypeChange("Distributor")}
          checked={sellerTypes.includes("Distributor")}
        />
        <p className="w-[74px] h-[21px] font-medium text-[14px] text-black">
          Distributor
        </p>
      </div>

      <div className="flex flex-row gap-x-[10px] items-center justify-start w-[220px]">
        <input
          type="checkbox"
          className="w-[16px] h-[16px] bg-[#FF6300]"
          onChange={() => handleSellerTypeChange("Wholesaler")}
          checked={sellerTypes.includes("Wholesaler")}
        />
        <p className="w-[80px] h-[21px] font-medium text-[14px] text-black">
          Wholesaler
        </p>
      </div>

      <div className="flex flex-row gap-x-[10px] items-center justify-start w-[220px]">
        <input
          type="checkbox"
          className="w-[16px] h-[16px] bg-[#FF6300]"
          onChange={() => handleSellerTypeChange("Retailer")}
          checked={sellerTypes.includes("Retailer")}
        />
        <p className="w-[54px] h-[21px] font-medium text-[14px] text-black">
          Retailer
        </p>
      </div>
    </div>
  );

  const accordionItems = [
    {
      title: "Price Range",
      content: <ComponentA />,
    },
    {
      title: "Product Rating",
      content: <ComponentB />,
    },
    {
      title: "Seller Type",
      content: <ComponentC />,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const [supplierTab, setSupplierTab] = useState(false);

  return (
    <div>
      {/* <Navbar /> */}

      <div className="w-full h-[930px]">
        <div className="max-w-[1240px] m-auto h-[890px] flex flex-col mt-[30px] mb-[46px]">
          <div className="flex flex-row w-[1240px] items-center justify-start">
            <div className="flex flex-row gap-x-[7px] h-[24px] items-center justify-center w-auto">
              <p className="font-medium text-[12px] w-[63px] h-[17px]">
                Category :
              </p>
              <button
                className="flex flex-row items-center justify-center gap-x-[6px]"
                onClick={toggleDropdown}
                ref={dropdownRef}
              >
                <h3 className="w-auto h-[21px] font-semibold text-[14px]">
                  {selectedCategory}
                </h3>
                <svg
                  className="fill-current h-3 w-4 text-[#FF6300] cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.293 6.293a1 1 0 011.414 0L10 11.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              {dropdownOpen && (
                <div
                  className="absolute top-[210px] right-[1130px] mt-2 py-2 w-48 bg-white border rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] z-10"
                  ref={dropdownRef}
                >
                  {mainCategory.map((category, index) => (
                    <a
                      key={index}
                      className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px] cursor-pointer"
                      onClick={() => handleCategorySelect(category)}
                    >
                      {category}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <hr className="w-[24px] bg-black rotate-90 opacity-35" />

            <div className="flex flex-row gap-x-[7px] h-[24px] items-center justify-start w-auto">
              <p className="font-medium text-[12px] w-[100px] h-[17px]">
                Sub - Category :
              </p>
              <button
                className="flex flex-row items-center justify-center gap-x-[6px]"
                onClick={subCategoryToggle}
              >
                <h3 className="w-auto h-[21px] font-semibold text-[14px]">
                  {selectedSubCategory}
                </h3>
                <svg
                  className="fill-current h-3 w-4 text-[#FF6300] cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.293 6.293a1 1 0 011.414 0L10 11.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              {subCategoryDropdown && (
                <>
                  <div className="absolute top-[210px] right-[910px] mt-2 py-2 w-48 bg-white border rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] z-50">
                    {subCategories.map((subCategory, index) => (
                      <a
                        key={index}
                        className="block px-4 py-2 text-black hover:text-[#FF6300] font-semibold text-[14px] cursor-pointer"
                        onClick={() => handleSubCategorySelect(subCategory)}
                      >
                        {subCategory.subCategory}
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="w-[1240px] h-[873px] pt-[18px] flex flex-row items-start justify-between">
            <div className="w-[267px] h-[850px] rounded-[10px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] flex flex-col px-[17px] pt-[20px]">
              <div className="w-full flex items-center justify-start gap-x-[8px]">
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_5261)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.818249 0.799805H17.1819L10.6364 8.3678V13.5998L7.3637 15.1998V8.3678L0.818249 0.799805Z"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_5261">
                      <rect
                        width="18"
                        height="16"
                        fill="white"
                        transform="matrix(-1 0 0 1 18 0)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className="w-[40px] h-[24px] font-semibold text-[16px]">
                  Filter
                </p>
              </div>

              <hr className="w-[232px] h-[2px] bg-[#E9E9E9] mt-[20px]" />

              {/* Price Range */}
              <div className="">
                <button
                  className="flex items-center justify-between w-full text-black cursor-pointer h-[65px]"
                  onClick={() => setIsPriceRangeOpen(!isPriceRangeOpen)}
                >
                  <span className="text-black font-semibold text-[14px]">
                    Price Range
                  </span>
                  <svg
                    className={`w-[21px] h-[18px] transition-transform ${
                      isPriceRangeOpen ? "rotate-180" : ""
                    }`}
                    viewBox="0 0 21 18"
                    fill="none"
                  >
                    <path
                      d="M5.25 6.75L10.5 11.25L15.75 6.75"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                {isPriceRangeOpen && <div className="">{ComponentA()}</div>}

                <hr className="w-full h-[1px] bg-[#E9E9E9]" />
              </div>

              {/* Product Rating */}
              <div classNam="">
                <button
                  className="flex items-center justify-between w-full text-black cursor-pointer h-[65px]"
                  onClick={() => setIsProductRatingOpen(!isProductRatingOpen)}
                >
                  <span className="text-black font-semibold text-[14px]">
                    Product Rating
                  </span>
                  <svg
                    className={`w-[21px] h-[18px] transition-transform ${
                      isProductRatingOpen ? "rotate-180" : ""
                    }`}
                    viewBox="0 0 21 18"
                    fill="none"
                  >
                    <path
                      d="M5.25 6.75L10.5 11.25L15.75 6.75"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                {isProductRatingOpen && (
                  <div className="">
                    <ComponentB />
                  </div>
                )}

                <hr className="w-full h-[1px] bg-[#E9E9E9]" />
              </div>

              {/* Seller Type */}
              <div>
                <button
                  className="flex items-center justify-between w-full text-black cursor-pointer h-[65px]"
                  onClick={() => setIsSellerTypeOpen(!isSellerTypeOpen)}
                >
                  <span className="text-black font-semibold text-[14px]">
                    Seller Type
                  </span>
                  <svg
                    className={`w-[21px] h-[18px] transition-transform ${
                      isSellerTypeOpen ? "rotate-180" : ""
                    }`}
                    viewBox="0 0 21 18"
                    fill="none"
                  >
                    <path
                      d="M5.25 6.75L10.5 11.25L15.75 6.75"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                {isSellerTypeOpen && (
                  <div className="">
                    <ComponentC />
                  </div>
                )}

                <hr className="w-full h-[1px] bg-[#E9E9E9]" />
              </div>
            </div>
            <div className="w-[951px] h-[840px] flex flex-col">
              <div className="w-full h-[53px] flex items-end justify-between">
                <div className="flex w-[312px]">
                  {allProductsTab.map((tab, index) => (
                    <button
                      key={index}
                      className={`px-4 py-2 -mb-px border-b-2 transition-all duration-300 w-[148px] h-[39px] ${
                        productsTab === index
                          ? "border-[#FF6300] text-black font-semibold text-[16px]"
                          : "border-transparent text-black font-semibold text-[16px]"
                      }`}
                      onClick={() => setProductsTab(index)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                <div
                  className={`flex gap-x-[14px] items-center justify-center w-[288px] ${
                    productsTab === 1 ? "hidden" : ""
                  }`}
                >
                  <p className="w-[50px] h-[20px] font-semibold text-[14px]">
                    Sort By
                  </p>
                  <button
                    className="w-[224px] h-[41px] bg-white rounded-[5px] flex items-center justify-center p-[10px] gap-x-[56px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]"
                    onClick={sortByToggle}
                  >
                    <p className="w-[250px] h-[20px] font-medium text-[14px] text-start">
                      {selectedOption || "Featured"}
                    </p>
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.39604 5.54234C4.7532 5.81298 5.2468 5.81298 5.60396 5.54234L9.55676 2.54702C10.3207 1.96812 9.9113 0.75 8.9528 0.75H1.0472C0.0886946 0.75 -0.3207 1.96812 0.443244 2.54702L4.39604 5.54234Z"
                        fill="black"
                      />
                    </svg>
                  </button>

                  {sortByDropdown && (
                    <div
                      ref={dropdownRef}
                      className="absolute top-[300px] right-[147px] flex flex-col bg-white p-3 w-[240px] h-[275px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[10px] z-50"
                    >
                      <h3 className="w-[50px] h-[28px] font-semibold text-[14px]">
                        Sort By
                      </h3>
                      {Object.keys(options).map((option, index) => (
                        <label
                          key={index}
                          className="block cursor-pointer font-medium text-[14px] py-2"
                        >
                          <input
                            type="radio"
                            className="mr-2"
                            value={option}
                            checked={selectedOption === option}
                            onChange={() => handleOptionChange(option)}
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full h-auto">
                {productsTabContent.map((content, index) => (
                  <div
                    key={index}
                    className={`transition-opacity duration-300 ${
                      productsTab === index
                        ? "opacity-100"
                        : "opacity-0 absolute"
                    }`}
                  >
                    {productsTab === index && <div>{content.panel}</div>}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllProducts;
